import React from 'react';
import { AboutHero } from '../components/AboutHero';
import { OurStory } from '../components/OurStory';
import { VisionaryLeader } from '../components/VisionaryLeader';
import { MissionVision } from '../components/MissionVision';
import { TeamSection } from '../components/TeamSection';
import { AboutCTA } from '../components/AboutCTA';
import { Footer } from '../components/Footer';
export function AboutPage() {
  return <main className="min-h-screen bg-white" data-id="element-358">
      <AboutHero data-id="element-359" />
      <OurStory data-id="element-360" />
      <VisionaryLeader data-id="element-361" />
      <MissionVision data-id="element-362" />
      <TeamSection data-id="element-363" />
      <AboutCTA data-id="element-364" />
      <Footer data-id="element-365" />
    </main>;
}